import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  emrName: '',
  isSyncedWithFirm: false,
  clients: [],
  leadIdToPersonIdMap: {},
  facilities: [],
};

export const emrInfoSlice = createSlice({
  name: 'emrInfo',
  initialState: initialState,
  reducers: {
    clearEmrInfo: () => {
      return initialState;
    },

    setEmrName: (state, action) => {
      const emrName = action.payload;
      const isSyncedWithFirm = !!emrName;
      return { ...state, emrName, isSyncedWithFirm };
    },

    setLeadIdToPersonIdMap: (state, action) => {
      return { ...state, leadIdToPersonIdMap: action.payload };
    },

    setEmrClients: (state, action) => {
      return { ...state, clients: action.payload };
    },

    setEmrFacilities: (state, action) => {
      return { ...state, facilities: action.payload };
    },

    addEmrClient: (state, action) => {
      const extendedClients = [...state.clients, action.payload];
      return { ...state, clients: extendedClients };
    },

    setEmrClientFacility: (state, action) => {
      const { personId, facilityName } = action.payload;

      const clientToChange = state.clients.find((cl) => cl.personId === personId);
      const changedClient = { ...clientToChange, facilityName };
      const otherClients = state.clients.filter((cl) => cl.personId !== personId);
      const revisedClients = [...otherClients, changedClient];

      return { ...state, clients: revisedClients };
    },
  },
});

export const {
  clearEmrInfo,
  setEmrName,
  setEmrClients,
  setEmrFacilities,
  addEmrClient,
  setEmrClientFacility,
  setLeadIdToPersonIdMap,
} = emrInfoSlice.actions;

export default emrInfoSlice.reducer;
